import { Tag } from '@/components/tag/Tag'
import { kLrrContentStatusDefinitions, type DisplayableLrrContentStatus } from '@/agent-v2/references/lrr-content-status'

/**
 * The drift badge for a cited law. Achromatic rather than coloured: unlike a citator
 * treatment this is not a judgement about the law's soundness, only a note that the
 * text moved, so it must not compete with the caselaw warning badges beside it.
 *
 * tonal/Black per the design, whose tokens (True Gray/200 fill, True Gray/300 border,
 * Brand Neutral/950 text) match that pairing exactly.
 */
export function LrrContentStatusTag({ status }: { status: DisplayableLrrContentStatus }) {
  return (
    <Tag variant="tonal" color="Black" size="xs">
      {kLrrContentStatusDefinitions[status].label}
    </Tag>
  )
}
